import { render, staticRenderFns } from "./ReportMenuItem.vue?vue&type=template&id=28c4bf55&scoped=true&"
import script from "./ReportMenuItem.vue?vue&type=script&lang=js&"
export * from "./ReportMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./ReportMenuItem.vue?vue&type=style&index=0&id=28c4bf55&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c4bf55",
  null
  
)

export default component.exports